import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "./TextField";
import MenuItem from "./MenuItem";
import Button from "./Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";

const COMPLETED_FILTER_OPTIONS = [
  { value: "2", labelKey: "all" },
  { value: "1", labelKey: "completed" },
  { value: "0", labelKey: "notCompleted" },
];
const WANTED_FILTER_OPTIONS = [
  { value: "2", labelKey: "all" },
  { value: "1", labelKey: "schedule" },
  { value: "0", labelKey: "unScheduled" },
];
const BoolFilterSelect = ({ label, name, value, onChange, translate,options }) => (
  <TextField
    fullWidth
    margin="dense"
    select
    label={label}
    value={value ?? "2"}
    onChange={(e) => onChange(name, e.target.value)}
  >
    {options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {translate(option.labelKey)}
      </MenuItem>
    ))}
  </TextField>
);

const PmsPageFilters = ({
  values,
  onChange,
  onSubmit,
  onClear,
  translate,
  showWantedFilter = false,
  selectedTab,
  overDueRangeEnabled = true,
  dueRangeEnabled = true,
  onToggleOverDueRange,
  onToggleDueRange,
}) => (
  <Grid container spacing={1} alignItems="center" style={{ padding: "5px" }}>
    <Grid item xs={12} sm={6} md={2}>
      <TextField
        fullWidth
        margin="dense"
        label={translate("plateNo")}
        value={values.plateNo || ""}
        onChange={(e) => onChange("plateNo", e.target.value)}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={2}>
      <TextField
        fullWidth
        margin="dense"
        label={translate("type")}
        value={values.category || ""}
        onChange={(e) => onChange("category", e.target.value)}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={2}>
      <TextField
        fullWidth
        margin="dense"
        label={translate("category")}
        value={values.itemCode || ""}
        onChange={(e) => onChange("itemCode", e.target.value)}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={2}>
      <BoolFilterSelect
        label={translate("completed")}
        name="completed"
        value={values.completed}
        onChange={onChange}
        translate={translate}
        options={COMPLETED_FILTER_OPTIONS}
      />
    </Grid>
    {showWantedFilter && (
      <Grid item xs={12} sm={6} md={2}>
        <BoolFilterSelect
          label={translate("wanted")}
          name="wanted"
          value={values.wanted}
          onChange={onChange}
          translate={translate}
          options={WANTED_FILTER_OPTIONS}
        />
      </Grid>
    )}
    <Grid item>
      <Button size="small" onClick={onSubmit}>
        {translate("submit")}
      </Button>
    </Grid>
    <Grid item>
      <Button size="small" className="button-white" onClick={onClear}>
        {translate("clear")}
      </Button>
    </Grid>
    {selectedTab === "missedOpportunity" && (
      <Grid item>
        <Tooltip
          title={
            translate("overDueWillShowPrevious30DaysPredictions") ||
            "Over Due will show Previous 30 days Predictions"
          }
        >
          <FormControlLabel
            style={{ marginLeft: 0, marginRight: 0 }}
            control={
              <Checkbox
                color="primary"
                checked={!!overDueRangeEnabled}
                onChange={(e) => onToggleOverDueRange?.(e.target.checked)}
              />
            }
            label={
              translate("vehicleServicesOverDueCheckbox") ||
              "Vehicle Services Over Due"
            }
          />
        </Tooltip>
      </Grid>
    )}
    {selectedTab === "potentialOpportunity" && (
      <Grid item>
        <Tooltip
          title={
            translate("dueWillShowNext30DaysPredictions") ||
            "Due will show next 30 days Predictions"
          }
        >
          <FormControlLabel
            style={{ marginLeft: 0, marginRight: 0 }}
            control={
              <Checkbox
                color="primary"
                checked={!!dueRangeEnabled}
                onChange={(e) => onToggleDueRange?.(e.target.checked)}
              />
            }
            label={
              translate("vehicleServicesDueCheckbox") || "Vehicle Services Due"
            }
          />
        </Tooltip>
      </Grid>
    )}
  </Grid>
);

export default PmsPageFilters;
